<template>
  <div class="chooseindex">
    <div class="backbox">
      <div class="back" @click="backto">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div>
    <div v-if="showState == 0" class="infocontent">
      <div class="title">订单详情：</div>
      <div class="infos">
        <div>收款方：彦旭科技（武汉）有限公司</div>
        <div>订单号：{{this.$route.query.orderNum}}</div>
        <div v-if="this.$route.query.name">
          <div class="flex">
            <div>
              商品名称：{{this.$route.query.name}}
            </div>
            <div class="infosize">（{{this.$route.query.person}}人）</div>
            <div v-if="this.$route.query.buynum">{{this.$route.query.num*this.$route.query.buynum}}条</div>
            <div v-else>
              {{this.$route.query.num}}条
            </div>
          </div>
        </div>
        <div v-if="this.$route.query.smsnum">
          <div class="flex">
            <div>
              商品名称：{{this.$route.query.smsnum}}条x{{this.$route.query.number}}
            </div>
          </div>
        </div>
        <div style="margin-top:4px;">支付金额：<span>￥{{this.$route.query.total}}</span></div>
      </div>
      <!-- <h3 class="buy-title">
        实际支付金额
        <span>订单提交成功，请尽快付款！订单号：{{
            
          }}</span>
      </h3>
      <p class="price">￥{{ this.$route.query.total }}</p> -->
      <div class="price-container">
        <h3 class="buy-title">请选择支付方式：</h3>
        <div class="item-container">
          <div @click="nowActive = index" :class="[nowActive == index ? $route.query.smsnum?'active2': 'active' : '']" v-for="(item, index) in [
              '支付宝 扫码支付',
              '微信 扫码支付',
              '银行 转账支付',
            ]" :key="index">
            <img :src="imgList[index]" alt="" />
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="btn-container">
          <el-button class="login-btn" :style="{'background':this.$route.query.smsnum?'#FA6400':''}" @click="handlePay(nowActive)" type="primary">立即支付</el-button>
        </div>
      </div>
    </div>
    <div v-else-if="showState == 2">
      <div id>
        <bankPay :frompath='fullPath'></bankPay>
      </div>
    </div>
    <div v-else>
      <wechatPay :frompath='fullPath'> </wechatPay>
    </div>
  </div>
</template>

<script>
import ali from '../assets/alipay.png';
import bankpay from '../assets/bankpay.png';
import wepay from '../assets/wepay.png';
import bankPay from '../components/bankPay';
import wechatPay from '../components/wechatPay';

export default {
  props: [],
  name: 'index',
  props: {
    title: String,
    fullPath: String
  },
  components: {
    bankPay,
    wechatPay,
  },
  data () {
    return {
      nowActive: 0,
      showState: 0,
      imgList: [ali, wepay, bankpay],
      frompath: ''
    }
  },

  methods: {
    backto () {
      if (this.showState != 0) {
        this.showState = 0
      } else {
        this.$router.push(this.fullPath)
      }
    },
    handlePay (val) {
      this.frompath = this.fullPath
      console.log(this.frompath, 'c111c')
      switch (val) {
        case 0:
          let url =
            this.$http.defaults.baseURL +
            `/salary-service/open/alipay/${this.$route.query.orderNum}`
          window.open(url)
          this.$store.commit('orderStepBack')
          this.$store.commit('setPayDone', true)
          // this.$router.replace('/index/order')
          window.location.href='https://ucenter.joyousoa.com/#/enterpriseIndex'
          this.$store.commit('setPayDone', false)
          break
        case 1:
          this.showState = 1
          break
        case 2:
          this.showState = 2
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.item-container {
  > div {
    font-size: 14px;
    font-weight: 600;

    img {
      height: 100%;
      vertical-align: middle;
      margin-right:8px;
    }
  }
}

.active {
  border: 2px solid rgba(59, 196, 146, 0.2) !important;
  background-color: rgba(59, 196, 146, 0.2);
}
.active2 {
  border: 3px solid RGBA(250, 100, 0, 0.2) !important;
  // background-color: RGBA(250, 100, 0, 0.2);
}

.login-btn {
  width: 200px;
  height: 40px;
  border-radius: 20px;
  margin-top: 13px;
  color: #fff;
  border-color: #fff;
  font-size: 16px !important;
}

.chooseindex {
  width: 100%;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2c2d3a;
    line-height: 28px;
  }
  .infos {
    margin-top: 16px;
    div {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 30px;
      span {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2c2d3a;
        line-height: 32px;
      }
    }
  }
  .price {
    padding: 16px 5px;
    font-size: 32px;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
  }
  .price-container {
    margin-top: 25px;
    > div {
      display: flex;
      margin-top: 15px;
      > div {
        width: 224px;
        height: 56px;
        padding: 8px;
        margin-right: 24px;
        border-radius: 4px;
        border: 1px solid rgba(224, 234, 241, 1);
        cursor: pointer;
      }
    }
  }
}
.infosize {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 32px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}
.backbox {
  height: 57px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  .back {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2c2d3a;
    line-height: 57px;
    padding: 0 15px;
    cursor: pointer;
  }
}
.infocontent {
  background: #fff;
  padding: 15px 18px 30px 18px;
  border-radius: 8px;
  min-height: calc(100vh - 148px);
}
.buy-title{
  font-size:18px;
}
</style>
